/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_ButtonInputs */

const en_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace`)
};

const fr_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer`)
};

const de_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzen`)
};

const it_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituire`)
};

const ru_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заменять`)
};

const es_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar`)
};

const zh_cn2_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代替`)
};

const ja_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交換する`)
};

const hi_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिस्थापित करें`)
};

const pt_pt2_find_replace_replace_button = /** @type {(inputs: Find_Replace_Replace_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir`)
};

/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Find_Replace_Replace_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_button = /** @type {((inputs?: Find_Replace_Replace_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_replace_button(inputs)
	if (locale === "de") return de_find_replace_replace_button(inputs)
	if (locale === "it") return it_find_replace_replace_button(inputs)
	if (locale === "ru") return ru_find_replace_replace_button(inputs)
	if (locale === "es") return es_find_replace_replace_button(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_replace_button(inputs)
	if (locale === "ja") return ja_find_replace_replace_button(inputs)
	if (locale === "hi") return hi_find_replace_replace_button(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_replace_button(inputs)
	return en_find_replace_replace_button(inputs)
});